"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.ALIGNMENT = void 0;
var TRANSLATION = {
  contentTitle: 'Each guest gets:',
  guest: "{0} guests",
  off: 'OFF'
};
exports.TRANSLATION = TRANSLATION;
var ALIGNMENT = ['start', 'center', 'end'];
exports.ALIGNMENT = ALIGNMENT;